import ErrorPage from './Index'

const ErrorPage404 = () => {
  return (
    <ErrorPage
      code='404'
      errorText={
        <div>
          We can&rsquo;t seem to find the page you&rsquo;re looking for.<br />
          Here are some helpful links instead:
        </div>
      }
      showBackButton
    />
  )
}

export default ErrorPage404
